import { z } from "zod";

export const createSalaryAdvanceSchema = z
  .object({
    amount_mode: z.enum(["exact", "percent"]),
    amount: z.string(),
    percent: z.string(),
    advance_month: z.number().int().min(1).max(12),
    advance_year: z.number().int().min(2000).max(2100),
  })
  .superRefine((data, ctx) => {
    if (data.amount_mode === "exact") {
      if (!data.amount.trim()) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["amount"], message: "advance.errors.amountRequired" });
      } else if (isNaN(Number(data.amount)) || Number(data.amount) <= 0) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["amount"], message: "advance.errors.amountPositive" });
      }
    } else {
      if (!data.percent.trim()) {
        ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["percent"], message: "advance.errors.percentRequired" });
      } else {
        const value = Number(data.percent);
        if (isNaN(value) || value <= 0 || value > 100) {
          ctx.addIssue({ code: z.ZodIssueCode.custom, path: ["percent"], message: "advance.errors.percentInvalid" });
        }
      }
    }
  });

export type SalaryAdvanceFormValues = z.infer<typeof createSalaryAdvanceSchema>;

export const createEmployeeAdvanceSchema = z.object({
  amount: z
    .string()
    .min(1, { message: "advance.errors.amountRequired" })
    .refine((val) => !isNaN(Number(val)) && Number(val) > 0, {
      message: "advance.errors.amountPositive",
    }),
  document_number: z.string().min(1, { message: "advance.errors.documentNumberRequired" }),
  document_date: z
    .date({ message: "advance.errors.documentDateRequired" })
    .nullable()
    .refine((val) => val !== null, { message: "advance.errors.documentDateRequired" }),
  comment: z.string().optional(),
});

export interface EmployeeAdvanceFormValues {
  amount: string;
  document_number: string;
  document_date: Date | null;
  comment?: string;
}
